import React, { useEffect, useState, useRef, SyntheticEvent } from "react";
import styles from "./header.module.css";
import logoIcon from "../../base/assets/icons/logo.svg";
import { useLocation } from "react-router-dom"; 
import xIcon from "../../base/assets/icons/x.svg";
import searchIcon from "../../base/assets/icons/icons_search.svg";
import userIcon from "../../base/assets/icons/icons_user.svg";
import headerIcon from "../../base/assets/icons/mobile_header_button.svg";
import { observer } from "mobx-react";
import appStore from "../stores/AppStore";
import MenuDropDown from "./MenuDropDown";
import NormalizedLink from "../reusables/NormalizedLink";
import { Link, useNavigate } from "react-router-dom";
import MenuLogoutDropDown from "./MenuLogoutDropDown";
import userStore from "../stores/UserStore";
import delSearchIcon from "../../base/assets/images/bitmaps/delSearch.png";
import { useTranslation } from "react-i18next";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Collapsible from "./CollapsiblePanel";
import closeHeaderIcon from "../../base/assets/images/bitmaps/header_close.png";
import { Container, Nav, Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMsal } from "@azure/msal-react";
import dataWrapper from "../../base/reusables/dataWrapper";
import lessonStore from "../../modules/lesson/lessonStore";
import coursewareStore from "../../modules/courseware/coursewareStore";
import { useStandaloneMode } from "../contexts/StandaloneModeContext";

 //const promises = lessonStore.getLists();
 //const wrapper = dataWrapper(promises);
const Header = React.forwardRef<HTMLDivElement>((props, ref) => {
   // wrapper.read();
// useEffect(() => {
//   lessonStore.getLists();
// }, []);
  const { isStandaloneMode } = useStandaloneMode();
  const location = useLocation();
  const { t } = useTranslation();
  let navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [visible, toggleVisible] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [isLogout, setIsLogout] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isNavigationLoaded, setIsNavigationLoaded] = useState(false);
  const { instance } = useMsal();

  useEffect(() => {
    inputRef?.current?.focus();
    if (searchActive) {
      inputRef?.current?.focus();
    }
  }, [searchActive]);

  const handleResize = () => {
    appStore.setHeaderHeight(containerRef.current?.offsetHeight);
  };

  useEffect(() => {
    appStore.setHeaderHeight(containerRef.current?.offsetHeight);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const menuItems = appStore.header.links;

  // Track when navigation menu items have loaded
  useEffect(() => {
    if (menuItems && menuItems.length > 0) {
      setIsNavigationLoaded(true);
    }
  }, [menuItems]);

  // Determine if courseware tab should be visible
  // Only show courseware tab when ALL conditions are met:
  // 1. User has access (coursewareStore.hasAccess === true) 
  // 2. Main navigation has loaded (isNavigationLoaded === true)
  // 3. NOT in standalone mode (standalone = courseware is a separate site, not a tab)
  const showCoursewareTab = coursewareStore.hasAccess && isNavigationLoaded && !isStandaloneMode;

  const handleLogout = async () => {
    try {
      setIsLogout(true);
      appStore.incrementLoadingProcedure();
      await userStore.logout();
      userStore.logoutEntra(instance);
      navigate("/login");
    } catch (error: any) {
      // Error handled silently
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };



  const handleSearchValChange = (e: any) => {
    setSearchVal((e.target as HTMLInputElement).value);
  };

  const deleteValue = (event: any) =>
    event.key === "Enter" ? clearSearchVal() : "";

  const clearSearchVal = () => {
    setSearchVal("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Tab") return;

    if (e.key === "Enter") {
      if (appStore.isMobileResolution) {
        setSearchActive(false);
      }
      if (searchVal) {
        navigate(`/${t("Search-path")}?term=${searchVal}`);
      }
    }
  };

  const handleSearchClick = (
    event?: React.KeyboardEvent<HTMLInputElement> | any
  ) => {
    if (searchActive) {
      if (appStore.isMobileResolution) {
        setSearchActive(false);
      }
      if (searchVal) {
        navigate(`/${t("Search-path")}?term=${searchVal}`);
      }
    } else {
      setSearchActive(true);
    }
  };

  const handleSearchMobile = (event: any) => {
    handleSearchClick();
  };

  const handleClickOutsideSearchBox = () => {
    setSearchActive(false);
  };

  const renderMobile = () => {
    if (isStandaloneMode && location.pathname === '/courseware') {
      return renderStandaloneProfile();
    }
    
    return (
      <>
        {isLogout ? <div className={styles.logoutOverlay} /> : null}
        <div className={styles.header}>
          {visible ? (
            <button
              onClick={() => {
                toggleVisible(!visible);
              }}
              onKeyPress={(key) => {
                if (key.code === "Enter" || key.code === "Space")
                  toggleVisible(!visible);
              }}
              tabIndex={0}
            >
              <img height="32" src={xIcon} />
            </button>
          ) : (
            <div className={styles.mobile__rightItemsWrapper}>
              <button
                aria-expanded={visible}
                aria-controls="widget1"
                onClick={() => {
                  if (searchActive) {
                    setSearchActive(false);
                  }
                  toggleVisible(!visible);
                }}
                onKeyPress={(key) => {
                  if (key.code === "Enter" || key.code === "Space") {
                    if (searchActive) {
                      setSearchActive(false);
                    }
                    toggleVisible(!visible);
                  }
                }}
                tabIndex={0}
              >
                <img
                  src={headerIcon}
                  alt={t("Header-icon-button")}
                  className={styles.mobile__hanburger}
                />
              </button>
              <button
                onClick={handleSearchMobile}
                onKeyPress={(key) => {
                  if (key.code === "Enter" || key.code === "Space")
                    handleSearchMobile(key);
                }}
                tabIndex={0}
              >
                <img
                  src={searchIcon}
                  alt={t("Header-search-button")}
                  style={{ visibility: !searchActive ? "visible" : "hidden" }}
                />
              </button>
            </div>
          )}
          <Link className={styles.header__link} to="/">
            <div className={styles.header__development}>
              {appStore.header.title}
            </div>
          </Link>

          <Link to="/">
            <img
              className={styles.logo}
              width="152"
              src={logoIcon}
              alt={t("Header-Logo-alt")}
            />
          </Link>
        </div>
        {searchActive ? (
          <>
            <div
              className={styles.searchBoxMobileWrapper}
              onClick={handleClickOutsideSearchBox}
            ></div>
            <div className={styles.searchBoxMobile}>
              <div className={styles.search__mobile}>
                {searchActive ? (
                  <input
                    type="text"
                    onChange={handleSearchValChange}
                    ref={inputRef}
                    value={searchVal}
                    aria-label={t("Header-search-input")}
                    onKeyDown={handleKeyDown}
                  />
                ) : null}
                {searchActive && searchVal.length > 0 && (
                  <img
                    src={delSearchIcon}
                    tabIndex={0}
                    alt={t("Header-search-button")}
                    className={styles.delIcon}
                    onClick={clearSearchVal}
                  />
                )}
                <div
                  className={
                    searchActive
                      ? styles.search__image__active
                      : styles.search__image
                  }
                  onClick={handleSearchClick}
                >
                  <img
                    tabIndex={0}
                    src={searchIcon}
                    alt={t("Header-search-button")}
                  />
                </div>
              </div>
            </div>
            <div></div>
          </>
        ) : null}
        <SwipeableDrawer
          id="side-menu"
          anchor={"right"}
          tabIndex={0}
          open={visible}
          onClose={() => toggleVisible(false)}
          onOpen={() => {
            toggleVisible(true);
          }}
          PaperProps={{
            style: {
              left: 75,
            },
          }}
        //  className={styles.drawer}
        >
          <ul {...props} className={styles.menu}>
            <li className={styles.menu__header}>
              <h2
                onClick={() => {
                  navigate("/");
                  toggleVisible(false);
                }}
              >
                {t("Mobile-Menu-Header")}
              </h2>
            </li>
            <li className={styles.menu__header__close}>
              <button onClick={() => toggleVisible(false)}>
                <img
                  tabIndex={0}
                  src={closeHeaderIcon}
                  alt={t("Header-Close-alt")}
                />
              </button>
            </li>
            <li>
              <NormalizedLink
                className={styles.link}
                link={"/"}
                onLinkClick={() => toggleVisible(false)}
              >
                {t("Home-Page")}
              </NormalizedLink>
            </li>
            {menuItems && menuItems.map((item, i) => {
              return !item.links?.length ? (
                <li key={item.id || i}>
                  <NormalizedLink
                    className={styles.link}
                    link={item.url || ""}
                    onLinkClick={() => toggleVisible(false)}
                  >
                    {item.text}
                  </NormalizedLink>
                </li>
              ) : (
                <li
                  key={item.id || i}
                  style={{
                    overflow: "inherit",
                    height: "auto",
                  }}
                  className={styles.collapsibleLink}
                >
                  <Collapsible title={item.text}>
                    <>
                      {item.links.map((subItem, subIndex) => (
                        <NormalizedLink
                          key={`${item.text}-${subIndex}`}
                          className={styles.link}
                          link={subItem.url || ""}
                          onLinkClick={() => toggleVisible(false)}
                        >
                          <div className={styles.collapsedItem}>
                            {subItem.text}
                          </div>
                        </NormalizedLink>
                      ))}
                    </>
                  </Collapsible>
                </li>
              );
            })}
            {showCoursewareTab && (
              <li key="courseware-tab-mobile">
                <NormalizedLink
                  className={styles.link}
                  link="/courseware"
                  onLinkClick={() => toggleVisible(false)}
                >
                  {t("Courseware-Tab-Title")}
                </NormalizedLink>
              </li>
            )}
            <button
              aria-label={t("Header-disconnect")}
              className={styles.mobileLogout}
              onClick={handleLogout}
            >
              {t("Header-disconnect")}
            </button>
          </ul>
        </SwipeableDrawer>
      </>
    );
  };

  const renderStandaloneProfile = () => {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px 20px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6'
      }}>
        <div className={styles.profile}>
          <div className={styles.profile__photo}>
            <img src={userIcon} alt="user icon" />
          </div>
          <div className={styles.MenuLogoutDropDownWrapper} style={{minWidth: "100px"}}>
            <MenuLogoutDropDown
              onLogout={handleLogout}
              name={userStore.user?.fullName || ""}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderDesktop = () => {
    if (isStandaloneMode && location.pathname === '/courseware') {
      return renderStandaloneProfile();
    }
    
    return (
      <Navbar bg="light" expand="lg" aria-label="menu">
        <Container>
          <Navbar.Brand>
            <div className={styles.rightItems}>
              <div className={styles.logoWrapper}>
                <Link to="/">
                  {" "}
                  <img
                    className={styles.logo}
                    width="152"
                    src={logoIcon}
                    alt={t("Header-Logo-alt")}
                  />
                </Link>
              </div>
              <Link className={styles.header__link} to="/">
                <div className={styles.header__development}>
                  {appStore.header.title}
                </div>
              </Link>
            </div>
          </Navbar.Brand>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav {...props}>
              {menuItems && menuItems.map((item, i) => {
                return !item.links?.length ? (
                  <NormalizedLink
                    key={i + item.text}
                    className={styles.menuItem}
                    link={item.url || ""}
                  >
                    {item.text}
                    {item.url &&
                      decodeURI(location.pathname).localeCompare(
                        item.url
                      ) === 0 && (
                        <div className={styles.menuItemCheckedBorderBottom} />
                      )}
                  </NormalizedLink>
                ) : (
                  <MenuDropDown
                    key={i + item.text}
                    id={item.id?.toString()}
                    main={item}
                    secondary={item.links || []}
                    className={styles.dropdownContainer}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                  />
                );
              })}
              {showCoursewareTab && (
                <NormalizedLink
                  key="courseware-tab-desktop"
                  className={styles.menuItem}
                  link="/courseware"
                >
                  {t("Courseware-Tab-Title")}
                  {decodeURI(location.pathname).localeCompare("/courseware") === 0 && (
                    <div className={styles.menuItemCheckedBorderBottom} />
                  )}
                </NormalizedLink>
              )}
            </Nav>
          </Navbar.Collapse>

          <Navbar.Brand>
            <div
              className={
                searchActive ? styles.leftItemsSearchActive : styles.leftItems
              }
            >
              <div className={styles.search} tabIndex={-1}>
                {searchActive ? (
                  <input
                    type="text"
                    onChange={handleSearchValChange}
                    ref={inputRef}
                    value={searchVal}
                    aria-label={t("Header-search-input")}
                    onKeyDown={handleKeyDown}
                    className={styles.search__input}
                  />
                ) : (
                  <></>
                )}
                {searchActive && searchVal.length > 0 && (
                  <img
                    src={delSearchIcon}
                    alt={t("Header-search-button")}
                    className={styles.delIcon}
                    onClick={clearSearchVal}
                    onKeyDown={deleteValue}
                    tabIndex={0}
                  />
                )}
                <div
                  className={
                    searchActive
                      ? styles.search__image__active
                      : styles.search__image
                  }
                  onClick={handleSearchClick}
                  tabIndex={0}
                  onFocus={handleSearchClick}
                  onBlur={() => handleKeyDown}
                >
                  <img src={searchIcon} alt={t("Header-search-button")} />
                </div>
              </div>
            </div>
          </Navbar.Brand>

          <Navbar.Brand>
            <div className={styles.profile}>
              <div className={styles.profile__photo}>
                <img src={userIcon} alt="user icon" />
              </div>
              <div className={styles.MenuLogoutDropDownWrapper} style={{minWidth: "100px"}}>
                <MenuLogoutDropDown
                  onLogout={handleLogout}
                  name={userStore.user?.fullName || ""}
                />
              </div>
            </div>
          </Navbar.Brand>
        </Container>
      </Navbar>
    );
  };

  return (
    <React.Fragment>
      {!appStore.isMobileResolution ? renderDesktop() : renderMobile()}
    </React.Fragment>
  );
});

export default observer(Header);
